import styled from "@emotion/styled";



export const AQIWrapper = styled.div`
    margin-top: 5px;
    width: 100%;
    border-radius: 10px;
    position: relative;
`;
export const AQIBarWrapper = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 
            1.8fr
            1.8fr
            1.8fr
            1.8fr
            1.8fr;
    grid-template-rows: 10px auto;
    column-gap: 4px;
    row-gap: 24px;
    
    & > div:nth-child(1) {
        background-color: #65C466;
        border-radius: 10px 0 0 10px;
    }
    & > div:nth-child(2) {
        background-color: #F6CC45;
    }
    & > div:nth-child(3) {
        background-color: #ED773A;
    }
    & > div:nth-child(4) {
        background-color: #EA445A;
    }
    & > div:nth-child(5) {
        background-color: #6D2634;
        border-radius: 0 10px 10px 0;
    }
`;

export const Measure = styled.div`
    display: flex;
    align-items: center;
`;
export const Name = styled.div`
    margin-left: 2px;
    font-size: 14px;
    color: #5F5F5F;
    font-weight: normal;
    margin-right: 2px;
    white-space: nowrap;
`;
export const VLine = styled.div`
    background-color: #9D9D9D;
    height: 8px;
    min-width: 1px;
`;
export const HLine = styled.div`
    background-color: #9D9D9D;
    height: 1px;
    flex: 1;
`;


export const AQIBar = styled.div`
    width: 100%;
    height: 100%;
`

export const AQIThumb = styled.div`
    background: #fff;
    border: 3px solid #449DF7;
    border-radius: 20px;
    height: 23px;
    width: 9px;
    box-sizing: content-box;
    position: absolute;
    top: 0;
    transform: translate(-50%, calc(-50% + 5px));
`;
